export const RECENSIONI_TIPO_PRENOTAZIONE_SERVIZIO = 'recensione_tipo.prenotazione_servizio';
export const RECENSIONI_TIPO_ORDINE = 'recensione_tipo.ordine';
export const RECENSIONI_TIPO_PRENOTAZIONE_GRUPPO = 'recensione_tipo.prenotazione_gruppo';
export const RECENSIONI_TIPO_PRENOTAZIONE_CAMERA = 'recensione_tipo.prenotazione_camera';
export const RECENSIONI_TIPO_PRENOTAZIONE_POSTI = 'recensione_tipo.prenotazione_posti';